import { useTheme } from "../../../../context/theme";
import {
  ACTIVE_OVERLAY_OPACITY,
  HOVER_OVERLAY_OPACITY
} from "../../../../styles/colors/consts";
import useStateColor from "../../../../styles/colors/surfaces/useStateColor";
import { Role } from "../../../../styles/colors/types";
import colorWithOpacity from "../../../../utils/colorWithOpacity";
import { ButtonFill, ButtonTone } from "../types";

export default function useButtonColorStyleProps({
  fill,
  tone,
  disabled
}: {
  fill: ButtonFill;
  tone: ButtonTone;
  disabled: boolean;
}) {
  const theme = useTheme();

  let roles: {
    backgroundColor: Role;
    color: Role;
  };

  if (fill === "outlined") {
    roles = {
      backgroundColor: `${tone}-high-content`,
      color: `${tone}-high-content`
    };

    return {
      backgroundColor: "transparent",
      color: theme[roles.color],
      hoverStyles: disabled
        ? undefined
        : {
            backgroundColor: colorWithOpacity(
              theme[roles.backgroundColor],
              HOVER_OVERLAY_OPACITY
            )
          },
      activeStyles: disabled
        ? undefined
        : {
            backgroundColor: colorWithOpacity(
              theme[roles.backgroundColor],
              ACTIVE_OVERLAY_OPACITY
            )
          }
    };
  } else {
    if (fill === "filled") {
      roles = {
        backgroundColor: `${tone}-high-surface`,
        color: `contentOn-${tone}-high-surface`
      };
    } else {
      roles = {
        backgroundColor: `${tone}-medium-surface`,
        color: `${tone}-high-content`
      };
    }
  }

  const hoverColor = useStateColor(theme[roles.backgroundColor], "hover");
  const activeColor = useStateColor(theme[roles.backgroundColor], "active");

  return {
    backgroundColor: theme[roles.backgroundColor],
    color: theme[roles.color],
    hoverStyles: disabled
      ? undefined
      : {
          backgroundColor: hoverColor
        },
    activeStyles: disabled
      ? undefined
      : {
          backgroundColor: activeColor
        }
  };
}
